import { FormBuilder, FormGroup, Validators, FormsModule, ReactiveFormsModule, FormControl, FormArray} from '@angular/forms';
import { Router } from '@angular/router';
import { HttpService } from '../../../utility/http-service';
import { CronOptions } from '../../../components/cron-editor/CronOptions';
import { CronFlavor } from '../../../components/cron-editor/enums';
import { Component, Output, OnInit, EventEmitter, Inject, Input} from '@angular/core';
import { ScheduleFilters } from '../model';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatDialog } from '@angular/material/dialog';
import { EditDialogService } from '../../../utility/dialog/edit-dialog-service';
import { LoginService } from '../../../../services/login-service';
import { Observable } from 'rxjs';
import { HttpHeaders } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { CronGenComponent } from '../../../components/cron-editor/cron-editor.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-add-job',
  templateUrl: './add-job.component.html',
  styleUrls: ['./add-job.component.css'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatSelectModule,
    MatOptionModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatCardModule,
    CronGenComponent, // if used
  ],
})
export class AddJobComponent implements OnInit {
  @Output() jobAdded = new EventEmitter<boolean>();
  @Input() dialogTitle: string = 'Add Job';
 
  jobForm!: FormGroup;
  isCronDisabled = false;
  companies: { id: string, name: string }[] = [];
  dataSources = [{ id: 'ftp', name: 'Ftp' }, { id: 'sftp', name: 'Sftp' }];
  timezones: { id: string, name: string }[] = [];
  isDataSourceConfigVisible = false;
  public cronExpression = '0 1 1/1 * *';
  public cronOptions: CronOptions = {
    formInputClass: 'form-control cron-editor-input',
    formSelectClass: 'form-control cron-editor-select',
    formRadioClass: 'cron-editor-radio',
    formCheckboxClass: 'cron-editor-checkbox',
    defaultTime: '00:00:00',
    hideMinutesTab: true,
    hideHourlyTab: true,
    hideDailyTab: false,
    hideWeeklyTab: true,
    hideMonthlyTab: false,
    hideYearlyTab: true,
    hideAdvancedTab: true,
    hideSpecificWeekDayTab: true,
    hideSpecificMonthWeekTab: true,
    use24HourTime: true,
    hideSeconds: false,
    cronFlavor: CronFlavor.standard
  };

  selectedFunction: string = '';
  fileRegex: string = '';
  regions: string[] = [];
  description: string = '';
  stateCounty: string = '';
  operator: string = '';
  numDays: string = 'allFuture';
  isGlobalAdmin: boolean = false;
  clients: { id: string, displayName: string }[] = [];
  integrationTypeString = [{ id: '1', name: 'Import' }, { id: '2', name: 'Export' }];
  filters: ScheduleFilters = { operators: [], regions: [], stateCounty: [] }; 
  scheduleOptions = [
    { value: 'allFuture', label: 'All Future Activity' },
    { value: 'next30', label: 'Next 30 Days' },
    { value: 'next60', label: 'Next 60 Days' },
    { value: 'next90', label: 'Next 90 Days' },
    { value: 'past30', label: 'Past 30 Days' },
    { value: 'past60', label: 'Past 60 Days' },
    { value: 'past90', label: 'Past 90 Days' },
    { value: 'allPast', label: 'All Past Activities' },
    { value: 'all', label: 'All Activities' }
  ];
  selectedJob: any;
  dataSource: string = '';
  constructor(
    private fb: FormBuilder,
    private router: Router,
    private http: HttpService,
    public dialogRef: MatDialogRef<AddJobComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
    public dialogService: EditDialogService,
    private loginService: LoginService,
  ) { }

  ngOnInit(): void {

    var regionArr : any[] = [];
    if (this.data?.filterOptions?.regionNames) {
      (this.data.filterOptions.regionNames as []).forEach(x => {
        regionArr.push(x);
      })
    }

    this.isGlobalAdmin = this.loginService.user.isGlobalAdmin;

    this.jobForm = this.fb.group({
      enabled: [true],
      clientId: ['', this.isGlobalAdmin ? Validators.required : Validators.nullValidator],
      integrationTypeString: ['', Validators.required],
      fileRegex: ['[a-zA-Z0-9]+.xlsx(?!\\.)', Validators.required],
      description: [''],
      dataSource: ['', Validators.required],
      ftpServer: ['', this.isDataSourceConfigVisible ? Validators.required : Validators.nullValidator],
      ftpPort: [21, Validators.required],
      ftpRootPath: ['/', Validators.nullValidator],
      ftpUser: ['', this.isDataSourceConfigVisible ? Validators.required : Validators.nullValidator],
      ftpPassword: ['', this.isDataSourceConfigVisible ? Validators.required : Validators.nullValidator],
      sftpServer: ['', Validators.nullValidator], 
      sftpPort: [22, Validators.required],
      sftpRootPath: ['/', Validators.nullValidator], 
      sftpUser: ['', Validators.nullValidator],    
      sftpPassword: ['', Validators.nullValidator],
      timeout: [30000],
      enableSecureFtp: [false],
      enableCertificateValidation: [false],
      enablePassiveMode: [false],
      selectedDays: this.fb.array([]),
      region: [regionArr],
      stateCounty: [''],
      operator:  [''],
      numDays: [''],
    });
   
    if (this.data) {
      this.selectedJob = this.data;
      this.cronExpression = this.data.cronSchedule;
      this.dialogTitle = 'Edit Job'; 
      this.populateForm(this.selectedJob);
    } else {
      this.dialogTitle = 'Add Job'; 
    }

    this.loadFilters();
    if (this.isGlobalAdmin) this.loadClients();
  }

  loadClients(): void {
    this.http.get("ClientSettings/GetPossibleClients", (clients: { id: string, displayName: string }[]) => {
      this.clients = clients;
    });
  }

  loadFilters(): void {
    this.http.get("FracX/FilterValues", (filters: ScheduleFilters) => {
      this.companies = filters.operators.map(operator => ({
        id: operator.value,
        name: operator.caption
      }));
      this.filters = filters;
    });
  }

  populateForm(job: any): void {
    if (job) {
      // Patch values from selectedJob or default values if undefined
      this.jobForm.patchValue({
        enabled: job.enabled !== undefined ? job.enabled : true,
        clientId: job.clientId || '',
        integrationTypeString: job.integrationTypeString || '',
        fileRegex: job.scheduleFileRegex || '[a-zA-Z0-9]+.xlsx(?!\\.)',  
        description: job.description || '', 
        dataSource: job.transferProperties.Type || '',
        ftpServer: job.transferProperties.Server || '', 
        ftpPort: job.transferProperties.Port || 21, 
        ftpRootPath: job.transferProperties.RootPath || '/',  
        ftpUser: job.transferProperties.UserName || '',  
        ftpPassword: job.transferProperties.Password || '',  
        timeout: job.timeout || 30000,
        sftpServer: job.transferProperties.Server || '',
        sftpPort: job.transferProperties.Port || 22,
        sftpRootPath: job.transferProperties.RootPath || '/',
        sftpUser: job.transferProperties.UserName || '',
        sftpPassword: job.transferProperties.Password || '',  
        enableSecureFtp: job.transferProperties.EnableSecureFtp === 'true' || job.transferProperties.EnableSecureFtp === true ? true : false,
        enableCertificateValidation: job.transferProperties.EnableCertificateValidation === 'true' || job.transferProperties.EnableCertificateValidation === true ? true : false,
        enablePassiveMode: job.transferProperties.EnablePassiveMode === 'true' || job.transferProperties.EnablePassiveMode === true ? true : false,
        selectedDays: job.selectedDays || [],
        stateCounty: job.filterOptions?.stateCounty || '', 
        numDays: job.filterOptions?.numDays || '',
        operator: job.filterOptions?.clientId || '',
      });
    }

    this.selectedFunction = job.integrationTypeString === 'Import' ? 'Import' : 'Export';
    this.dataSource = job.transferProperties.Type || '';
    if (this.dataSource === 'Ftp' || this.dataSource === 'Sftp') {
      this.toggleDataSourceConfig();
    }

    this.operator = job.filterOptions?.clientId || '';

  }

  // Handle changes in the data source dropdown
  onDataSourceChange(): void {
    const dataSource = this.jobForm.get('dataSource')?.value;
    this.dataSource = dataSource;
    if (dataSource === 'Ftp') {
      this.jobForm.get('ftpPort')?.setValue(21); 
      this.jobForm.get('sftpPort')?.setValue(null);
    } else if (dataSource === 'Sftp') {
      this.jobForm.get('sftpPort')?.setValue(22); 
      this.jobForm.get('ftpPort')?.setValue(null);
    }
    this.jobForm.updateValueAndValidity();
    this.isDataSourceConfigVisible = true;
    this.toggleDataSourceConfig();
  }

  toggleDataSourceConfig(): void {
    this.isDataSourceConfigVisible = !this.isDataSourceConfigVisible;
    this.clearAllValidators();

    if (this.isDataSourceConfigVisible) {
      if (this.dataSource === 'Ftp') {
        this.addFtpValidators(); 
      } else if (this.dataSource === 'Sftp') {
        this.addSftpValidators(); 
      }
    } else {
      this.clearAllValidators(); 
    }
    this.jobForm.updateValueAndValidity();
  }

  clearAllValidators(): void {
    const ftpFields = ['ftpServer', 'ftpRootPath', 'ftpUser', 'ftpPassword', 'ftpPort'];
    ftpFields.forEach(field => {
      this.jobForm.get(field)?.clearValidators();
      this.jobForm.get(field)?.updateValueAndValidity();
    });
    const sftpFields = ['sftpServer', 'sftpRootPath', 'sftpUser', 'sftpPassword', 'sftpPort'];
    sftpFields.forEach(field => {
      this.jobForm.get(field)?.clearValidators();
      this.jobForm.get(field)?.updateValueAndValidity();
    });
  }

  // Add Ftp-specific validators
  addFtpValidators(): void {
    const ftpFields = ['ftpServer', 'ftpRootPath', 'ftpUser', 'ftpPassword', 'ftpPort'];
    ftpFields.forEach(field => {
      this.jobForm.get(field)?.setValidators(Validators.required);
      this.jobForm.get(field)?.updateValueAndValidity();
    });
  }

  // Add Sftp-specific validators
  addSftpValidators(): void {
    const sftpFields = ['sftpServer', 'sftpRootPath', 'sftpUser', 'sftpPassword', 'sftpPort'];
    sftpFields.forEach(field => {
      this.jobForm.get(field)?.setValidators(Validators.required);
      this.jobForm.get(field)?.updateValueAndValidity();
    });
  }


  onSubmit(): void {
    if (this.jobForm.valid) {
      const jobData = this.jobForm.value;
      const dataSource = jobData.dataSource;
      this.dataSource = dataSource;
      let transferProperties: { [key: string]: string } = {
        Type: dataSource,  
      };

      // Add Ftp or Sftp specific properties based on the dataSource
      if (dataSource === 'Ftp') {
        transferProperties = {
          ...transferProperties,
          Server: jobData.ftpServer,
          Port: jobData.ftpPort.toString(),
          RootPath: jobData.ftpRootPath,
          UserName: jobData.ftpUser,
          Password: jobData.ftpPassword,
          Timeout: jobData.timeout.toString(),
          EnableSecureFtp: jobData.enableSecureFtp ? 'true' : 'false',
          EnableCertificateValidation: jobData.enableCertificateValidation ? 'true' : 'false',
          EnablePassiveMode: jobData.enablePassiveMode ? 'true' : 'false',
          

        };
      } else if (dataSource === 'Sftp') {
        transferProperties = {
          ...transferProperties,
          Server: jobData.sftpServer,
          Port: jobData.sftpPort.toString(),
          RootPath: jobData.sftpRootPath,
          UserName: jobData.sftpUser,
          Password: jobData.sftpPassword,
          Timeout: jobData.timeout.toString(),

        };
      }

      let filterOptions = null;
      if (jobData.integrationTypeString === 'Export') {
        filterOptions = {
          regionNames: jobData.region || [], 
          stateCounty: jobData.stateCounty || 'empty',
          numDays: jobData.numDays || '30',
          clientId: jobData.operator || '',
        };
      }

      const fracXSyncOptions: any = {
        description: jobData.description,
        integrationType: jobData.integrationTypeString === 'Import' ? 0 : 1,
        enabled: jobData.enabled,
        cronSchedule: this.cronExpression,
        transferProperties: { ...transferProperties },
        scheduleFileRegex: jobData.integrationTypeString === 'Import' ? jobData.fileRegex : null,
        filterOptions: filterOptions,
        clientId: this.isGlobalAdmin ? jobData.clientId : undefined,
      };
      // **Check if it's Edit or Add**:
      if (this.data && this.data.recordId) {
        fracXSyncOptions.recordId = this.data.recordId;
        this.updateSyncOptions(fracXSyncOptions).subscribe(
          (response) => {
            if (response && response.message === 'Sync option updated successfully.') {
              this.dialogRef.close({ success: true });
              this.dialogRef.afterClosed().subscribe(() => {
                this.router.navigate(['/job-grid']); // stays in the same tab
              });
            } else {
              this.dialogRef.close({ success: false });
            }
          },
          (error) => {
            console.error('Error updating sync options:', error);
            this.dialogRef.close({ success: false });
          }
        );
      } else {
        this.updateSyncOptions(fracXSyncOptions).subscribe(
          (response) => {
            if (response && response.message === 'Sync option updated successfully.') {
              this.dialogRef.close({ success: true });

              this.dialogRef.afterClosed().subscribe(() => {
                this.router.navigate(['/job-grid']); // stays in the same tab
              });
              this.jobAdded.emit(true);
            } else {
              this.dialogRef.close({ success: false });
            }
          },
          (error) => {
            console.error('Error adding sync options:', error);
            this.dialogRef.close({ success: false });
          }
        );
      }
    }
  }

  onCancel(): void {
    this.dialog.closeAll();
  }

  onExit(): void {
    this.dialog.closeAll();

    this.dialog.afterAllClosed.subscribe(() => {
      this.router.navigate(['/job-grid']); 
    });
  }

  updateSyncOptions(fracXSyncOptions: any[]): Observable<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.http.post<any>(environment.apiConfig.uri + 'FracX/UpdateSyncOptions', fracXSyncOptions, { headers });
  }
}
